enum CardMode {

  WIDE = 'wide',
  DEFAULT = 'default',
  
}

export default CardMode;
